module.exports = __webpack_public_path__ + "fonts/brandon_med-webfont.80d9dca84e27e49382720a7fc0cb3ad4.woff";